/** Clarification requests are directed at the user, not queries to submit. */
export function answerActions(route?: string, followups: string[] = [], clarifications?: string[]) {
  const needsInput = route === 'clarification_required' || route?.startsWith('refuse_');
  return {
    questions: needsInput ? [] : followups,
    clarifications: clarifications ?? (needsInput ? followups : []),
  };
}

interface RetryMessage {
  id: number;
  role: 'user' | 'ai';
  text: string;
  error?: { message: string };
}

export function restoredAnswerFailure(role: string, text: string, error?: { code?: string; message: string }) {
  return role === 'user' && error?.message ? {
    role: 'ai' as const, text: '', error, retryText: text, streaming: false,
  } : null;
}

/** Reuse the failed bubble and its user turn; never append another question. */
export function beginAssistantRetry<T extends RetryMessage>(messages: T[], aiId: number) {
  const last = messages.at(-1);
  const user = messages.at(-2);
  if (last?.id !== aiId || last.role !== 'ai' || !last.error || user?.role !== 'user') return null;
  const retryMessage = {
    ...last, text: '', streaming: true, error: undefined, retryText: undefined,
    citations: [], images: [], books: [], relatedSpecies: [], followups: [], clarifications: [],
    route: undefined, intent: undefined,
  };
  return { text: user.text, aiId, messages: [...messages.slice(0, -1), retryMessage] };
}
